//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, computed, onMounted } from '@nuxtjs/composition-api';
import { SfTextarea, SfButton, SfInput } from '@storefront-ui/vue';
import { useUser, userGetters, useEmail } from '@bee-hole/coms';
export default {
  name: 'Contactus',
  components: {
    SfTextarea,
    SfButton,
    SfInput
  },
  layout({ app }) {
    return app?.$storeConfig?.mall_home_type || 'default';
  },
  setup(props, context) {
    const { user, load: loadUser } = useUser();
    const fileInput = ref();
    const { sendEmail, loading } = useEmail();
    const formData = ref(Object.assign({}, {
      subject: '',
      author_email: '',
      content: '',
      auth_title: '',
      type: 0
    }));
    const uploadImage = () => {
      formData.value.image.push(URL.createObjectURL(fileInput?.value?.files[0] || ''));
    };
    const clickUpload = () => {
      fileInput.value.click();
    };
    const submitEmail = async () => {
      localStorage.setItem('contactus', JSON.stringify(formData.value));
      await sendEmail(formData.value);
      if (loading.value === false) {
        localStorage.removeItem('contactus');
        formData.value = Object.assign({}, {
          subject: '',
          author_email: '',
          content: '',
          auth_title: '',
          type: 0
        });
      }
    };
    const bgColor = computed(() => {
      if (context?.root.$options.$storeConfig?.mall_home_type === 'website') {
        const config = context?.root?.$options?.$mallConfig?.mall_home_artice;
        return config?.bgColor || '#09194c';
      } else {
        return '#fff';
      }
    });
    const borderColor1 = computed(() => {
      return bgColor.value === '#fff' ? '#000' : '#fff';
    });
    const fontColor = computed(() => {
      if (context?.root.$options.$storeConfig?.mall_home_type === 'website') {
        const config = context?.root?.$options?.$mallConfig?.mall_home_artice;
        return config?.fontColor || '#ffffff';
      } else {
        return '#000';
      }
    });
    onMounted(async () => {
      const data = localStorage.getItem('contactus');
      if (data) {
        formData.value = JSON.parse(data);
      }
      await loadUser();
      if (user.value) {
        formData.value.author_email = (userGetters.getEmailAddress(user.value));
      }
    });
    return {
      formData,
      uploadImage,
      clickUpload,
      fileInput,
      submitEmail,
      bgColor,
      fontColor,
      borderColor1
    };
  }
};
